import type { api, Quote } from './api';
import { WORKFLOW_METIN as M } from './metin/workflow';

export function accessibleSalesStep(target: number, customerId: string, itemCount: number): number {
  if (target > 0 && !customerId) return 0;
  if (target > 1 && itemCount === 0) return 1;
  return target;
}

/** Publication must succeed before a real payment link may be requested. Does not send messages. */
export async function prepareQuotePayment(
  quote: Quote,
  gateway: Pick<typeof api, 'publishQuote' | 'createPaymentLink'>,
  onPublished: (quote: Quote) => Promise<unknown>,
) {
  const status = quote.versions.find(version => version.versionNo === quote.currentVersionNo)?.status;
  if (status !== 'DRAFT' && status !== 'PUBLISHED') throw new Error(M.satis.yalnizYayimliSurumUyarisi);
  let current = quote;
  if (status === 'DRAFT') {
    current = await gateway.publishQuote(quote.id, { versionNo: quote.currentVersionNo, expectedQuoteVersion: quote.version });
    await onPublished(current);
  }
  return gateway.createPaymentLink(current.id, current.currentVersionNo);
}

/**
 * Musteri degisirken acik firsat baginin kaderi. Firsat bir musteriye aittir: baska bir musteriye
 * gecildiyse eski firsat temizlenir, yoksa teklif yeni musterinin adina eski firsattan uretilirdi.
 * Ayni musteri secilirse firsat korunur.
 */
export function opportunityAfterCustomerChange(currentCustomerId: string, nextCustomerId: string, opportunityId: string): string {
  return nextCustomerId === currentCustomerId ? opportunityId : '';
}

/**
 * Talep kaydi POST'u basarili olup sonraki adim (fiyat kutusu) dustuyse, ayni metinle yeniden
 * denemede yeni talep acilmaz: ayni kayit kullanilir. Basarili bitisten sonra cagiran `current`i
 * null yapar.
 */
export async function reuseOrCreate<T>(store: { current: { text: string; record: T } | null }, text: string, create: () => Promise<T>): Promise<T> {
  if (store.current?.text === text) return store.current.record;
  const record = await create();
  store.current = { text, record };
  return record;
}
